export default __webpack_public_path__ + "static/media/IMG_5182.4a19a0dd.jpeg";